var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataScienceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1937_4294)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.493164,
    width: 50,
    height: 50,
    rx: 12,
    fill: "url(#paint0_linear_1937_4294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.993164,
    width: 49,
    height: 49,
    rx: 11.5,
    stroke: "url(#paint1_radial_1937_4294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.993164,
    width: 49,
    height: 49,
    rx: 11.5,
    stroke: "url(#paint2_radial_1937_4294)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.993164,
    width: 49,
    height: 49,
    rx: 11.5,
    stroke: "url(#paint3_radial_1937_4294)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2246 24.3987C22.1897 24.9147 22.1714 25.4476 22.1714 25.9932C22.1714 26.5387 22.1897 27.0716 22.2246 27.5877C22.656 27.876 23.1103 28.1584 23.5848 28.4313C24.0597 28.7045 24.5328 28.9555 24.9996 29.1837C25.4663 28.9555 25.9395 28.7045 26.4144 28.4313C26.8889 28.1584 27.3432 27.876 27.7746 27.5877C27.8094 27.0716 27.8277 26.5387 27.8277 25.9932C27.8277 25.4476 27.8094 24.9147 27.7746 24.3987C27.3432 24.1104 26.8888 23.8279 26.4144 23.555C25.9394 23.2818 25.4663 23.0308 24.9996 22.8026C24.5328 23.0308 24.0598 23.2818 23.5848 23.555C23.1103 23.8279 22.656 24.1104 22.2246 24.3987ZM21.186 25.1368C21.1763 25.419 21.1714 25.7047 21.1714 25.9932C21.1714 26.2817 21.1763 26.5673 21.186 26.8496C20.8107 26.5657 20.4586 26.2791 20.1323 25.9932C20.4586 25.7072 20.8107 25.4207 21.186 25.1368ZM21.265 23.8433C20.5824 24.3203 19.9561 24.8127 19.3978 25.3075C19.1317 25.0418 18.8899 24.7787 18.6747 24.5211C18.1394 23.8804 17.7859 23.2947 17.6161 22.8017C17.4457 22.3073 17.4787 21.9686 17.6089 21.7439C17.7394 21.5187 18.0183 21.3203 18.5343 21.2198C19.0486 21.1197 19.7351 21.1319 20.5598 21.2735C20.8909 21.3303 21.2399 21.4072 21.6035 21.5038C21.4528 22.2319 21.3382 23.0173 21.265 23.8433ZM22.3473 23.1301C22.5884 22.9802 22.8348 22.8328 23.0862 22.6882C23.336 22.5445 23.5859 22.4064 23.8351 22.2741C23.401 22.0925 22.9763 21.9323 22.5649 21.7939C22.4795 22.2181 22.4064 22.6647 22.3473 23.1301ZM22.7941 20.8163C23.5031 21.0505 24.244 21.3447 24.9996 21.695C25.7551 21.3447 26.4961 21.0505 27.2051 20.8163C27.1074 20.455 26.9999 20.1161 26.884 19.8026C26.5948 19.0206 26.2624 18.4228 25.9186 18.0295C25.5739 17.6353 25.262 17.4932 24.9996 17.4932C24.7372 17.4932 24.4252 17.6353 24.0805 18.0295C23.7367 18.4228 23.4043 19.0206 23.1152 19.8026C22.9992 20.1161 22.8918 20.455 22.7941 20.8163ZM27.4343 21.7939C27.0229 21.9323 26.5982 22.0925 26.1641 22.2741C26.4133 22.4064 26.6631 22.5445 26.913 22.6882C27.1644 22.8328 27.4108 22.9802 27.6519 23.1301C27.5927 22.6647 27.5197 22.2181 27.4343 21.7939ZM28.7342 23.8433C28.661 23.0173 28.5463 22.2319 28.3957 21.5038C28.7593 21.4072 29.1083 21.3303 29.4394 21.2735C30.2641 21.1319 30.9506 21.1197 31.4648 21.2198C31.9809 21.3203 32.2598 21.5187 32.3903 21.7439C32.5205 21.9686 32.5534 22.3073 32.3831 22.8017C32.2133 23.2947 31.8598 23.8804 31.3245 24.5211C31.1093 24.7787 30.8675 25.0417 30.6013 25.3075C30.0431 24.8127 29.4167 24.3203 28.7342 23.8433ZM28.8132 25.1367C28.8228 25.419 28.8277 25.7047 28.8277 25.9932C28.8277 26.2817 28.8228 26.5674 28.8132 26.8496C29.1885 26.5657 29.5406 26.2792 29.8669 25.9932C29.5406 25.7072 29.1885 25.4207 28.8132 25.1367ZM30.6013 26.6788C30.0431 27.1736 29.4167 27.6661 28.7342 28.143C28.661 28.969 28.5463 29.7545 28.3957 30.4825C28.7593 30.5791 29.1083 30.656 29.4394 30.7129C30.2641 30.8544 30.9505 30.8666 31.4648 30.7665C31.9808 30.666 32.2598 30.4676 32.3903 30.2425C32.5205 30.0178 32.5534 29.679 32.3831 29.1846C32.2133 28.6916 31.8598 28.1059 31.3245 27.4652C31.1092 27.2076 30.8675 26.9446 30.6013 26.6788ZM27.4343 30.1924C27.5197 29.7683 27.5927 29.3216 27.6519 28.8563C27.4108 29.0061 27.1644 29.1535 26.913 29.2981C26.6632 29.4418 26.4133 29.5799 26.1641 29.7122C26.5982 29.8938 27.0229 30.0541 27.4343 30.1924ZM24.9996 30.2913C25.7551 30.6417 26.4961 30.9358 27.2051 31.1701C27.1074 31.5313 26.9999 31.8702 26.884 32.1837C26.5948 32.9657 26.2624 33.5636 25.9186 33.9568C25.5739 34.3511 25.262 34.4932 24.9996 34.4932C24.7372 34.4932 24.4252 34.3511 24.0805 33.9568C23.7367 33.5636 23.4044 32.9657 23.1152 32.1837C22.9992 31.8702 22.8918 31.5313 22.7941 31.1701C23.5031 30.9358 24.244 30.6417 24.9996 30.2913ZM23.8351 29.7122C23.5858 29.5799 23.336 29.4418 23.0862 29.2981C22.8348 29.1535 22.5884 29.0061 22.3473 28.8563C22.4064 29.3216 22.4795 29.7683 22.5649 30.1924C22.9763 30.0541 23.401 29.8938 23.8351 29.7122ZM21.6035 30.4825C21.4528 29.7545 21.3382 28.969 21.265 28.143C20.5825 27.6661 19.9561 27.1736 19.3978 26.6788C19.1317 26.9446 18.89 27.2076 18.6747 27.4652C18.1394 28.1059 17.7859 28.6916 17.6161 29.1846C17.4458 29.679 17.4787 30.0177 17.6089 30.2425C17.7394 30.4676 18.0183 30.666 18.5344 30.7665C19.0487 30.8666 19.7351 30.8544 20.5598 30.7128C20.8909 30.656 21.2399 30.5791 21.6035 30.4825ZM18.6693 25.9932C18.3911 25.7142 18.1364 25.4365 17.9073 25.1623C17.328 24.4689 16.8943 23.7769 16.6706 23.1274C16.4473 22.4793 16.4144 21.8107 16.7437 21.2425C17.0727 20.6747 17.6693 20.3695 18.3432 20.2383C19.0189 20.1067 19.8367 20.1348 20.7289 20.2879C21.0828 20.3486 21.4527 20.4298 21.8354 20.5308C21.939 20.1505 22.0532 19.7912 22.1773 19.4558C22.4904 18.6091 22.8751 17.8889 23.3277 17.3713C23.7793 16.8547 24.3429 16.4932 24.9996 16.4932C25.6562 16.4932 26.2198 16.8547 26.6715 17.3713C27.124 17.8889 27.5088 18.6091 27.8219 19.4558C27.9459 19.7911 28.0602 20.1505 28.1637 20.5308C28.5465 20.4298 28.9164 20.3486 29.2703 20.2879C30.1624 20.1347 30.9803 20.1067 31.656 20.2383C32.3299 20.3695 32.9265 20.6747 33.2555 21.2425C33.5848 21.8107 33.5519 22.4793 33.3286 23.1274C33.1049 23.7769 32.6712 24.4689 32.0919 25.1623C31.8628 25.4365 31.6081 25.7142 31.3299 25.9932C31.6081 26.2721 31.8628 26.5499 32.0919 26.8241C32.6712 27.5174 33.1048 28.2095 33.3286 28.8589C33.5518 29.5071 33.5848 30.1756 33.2555 30.7439C32.9265 31.3117 32.3298 31.6169 31.6559 31.7481C30.9802 31.8796 30.1624 31.8516 29.2702 31.6984C28.9164 31.6377 28.5465 31.5565 28.1638 31.4556C28.0602 31.8358 27.9459 32.1952 27.8219 32.5305C27.5088 33.3772 27.124 34.0974 26.6715 34.615C26.2198 35.1316 25.6562 35.4932 24.9996 35.4932C24.3429 35.4932 23.7793 35.1316 23.3277 34.615C22.8751 34.0974 22.4904 33.3772 22.1773 32.5305C22.0532 32.1952 21.939 31.8358 21.8354 31.4556C21.4527 31.5565 21.0828 31.6377 20.729 31.6984C19.8368 31.8516 19.019 31.8796 18.3433 31.748C17.6694 31.6168 17.0727 31.3117 16.7437 30.7439C16.4144 30.1756 16.4474 29.5071 16.6706 28.8589C16.8944 28.2094 17.328 27.5174 17.9073 26.824C18.1364 26.5499 18.3911 26.2721 18.6693 25.9932Z",
    fill: "#66C19A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1937_4294",
    x: -7.9,
    y: -7.40684,
    width: 65.8,
    height: 65.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 3.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1937_4294"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1937_4294",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1937_4294",
    x1: -20,
    y1: -30.5369,
    x2: 75.8258,
    y2: 8.56886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBCC7",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBCC7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1937_4294",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-26.6228 5.60829) rotate(35.1112) scale(57.6443 34.0523)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1937_4294",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.6381 33.9561) rotate(161.34) scale(41.7879 28.303)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DFFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DFFCF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1937_4294",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3.21518e-06 -25.5068) rotate(38.2701) scale(56.6765 40.7288)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataScienceIcon);
export default __webpack_public_path__ + "static/media/data-science_icon.bc6e1fa50d11b542e7ff0ee68eac3ed8.svg";
export { ForwardRef as ReactComponent };